<template>
  <div class="load1" v-if="show">
    <img
      src="../assets/img/loading/logoloading.gif"
      style="width: 60px; height: 60px"
      class="load2"
    />
    <img
      src="../assets/img/loading/logbgc.png"
      style="width: 60px; height: 60px"
      class="load"
    />
  </div>
</template>

<script>
export default {
  props: { show: Boolean },
};
</script>

<style scoped>
.load {
  position: absolute;
  z-index: 1;
}
.load2 {
  position: absolute;
  z-index: 2;
}
.load1 {
  width: 60px;
  height: 60px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}
</style>
